import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-882016ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "share-modal" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Share it!", -1))
const _hoisted_3 = { class: "share-items" }
const _hoisted_4 = ["href"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fab fa-facebook-square" }, null, -1))
const _hoisted_6 = ["href"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fab fa-linkedin" }, null, -1))
const _hoisted_8 = ["href"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fab fa-twitter-square" }, null, -1))
const _hoisted_10 = ["href"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-regular fa-envelope" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "overlay",
    onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)), ["self"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("a", {
          target: "_blank",
          class: "share-item",
          href: `https://www.facebook.com/share.php?v=4&src=bm&u=${_ctx.url}`
        }, [
          _hoisted_5,
          _createTextVNode(" Share on Facebook ")
        ], 8, _hoisted_4),
        _createElementVNode("a", {
          target: "_blank",
          class: "share-item",
          href: `https://www.linkedin.com/sharing/share-offsite/?url=${_ctx.url}`
        }, [
          _hoisted_7,
          _createTextVNode(" Share on Linkedin ")
        ], 8, _hoisted_6),
        _createElementVNode("a", {
          target: "_blank",
          class: "share-item",
          href: `https://twitter.com/intent/tweet?text=${_ctx.url}`
        }, [
          _hoisted_9,
          _createTextVNode(" Share on Twitter ")
        ], 8, _hoisted_8),
        _createElementVNode("a", {
          target: "_blank",
          class: "share-item",
          href: `mailto:?body=%20${_ctx.url}`
        }, [
          _hoisted_11,
          _createTextVNode(" Share on Email ")
        ], 8, _hoisted_10)
      ])
    ])
  ]))
}